import { tenantProfileKeys } from "@/hooks/useTenantProfile";
import { fileService } from "@/services/file-service";
import { tenantAdminService } from "@/services/tenant-admin-service";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const ALLOWED_TENANT_LOGO_TYPES = new Set([
  "image/png",
  "image/jpeg",
  "image/webp",
]);

export const useUploadTenantLogo = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, File>({
    mutationFn: async (file: File) => {
      const contentType = file.type.length > 0 ? file.type : "image/png";
      if (!ALLOWED_TENANT_LOGO_TYPES.has(contentType)) {
        throw new Error("Unsupported tenant logo content type");
      }

      const { uploadUrl } =
        await tenantAdminService.requestTenantLogoUpload(contentType);
      await fileService.uploadFileWithContentType(uploadUrl, file, contentType);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tenantProfileKeys.profile(),
      });
      queryClient.invalidateQueries({
        queryKey: tenantProfileKeys.logoUrl(),
      });
    },
  });
};
